var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer text-center text-info"},[_c('strong',[_vm._v("© 2021 "),_c('router-link',{staticClass:"text-info",attrs:{"to":"/"}},[_vm._v("OwnaRadio")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }